import { render, staticRenderFns } from "./MultipleChoiceCheckbox.vue?vue&type=template&id=1939e127&"
import script from "./MultipleChoiceCheckbox.vue?vue&type=script&lang=js&"
export * from "./MultipleChoiceCheckbox.vue?vue&type=script&lang=js&"
import style0 from "./MultipleChoiceCheckbox.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports